import axios from 'axios';

const state = {
  alquileres: [],
};

const mutations = {
  SET_ALQUILERES(state, alquileres) {
    state.alquileres = alquileres;
  },
  ADD_ALQUILER(state, alquiler) {
    state.alquileres.push(alquiler);
  },
  UPDATE_ALQUILER(state, alquiler) {
    const index = state.alquileres.findIndex(a => a.id === alquiler.id);
    if (index !== -1) {
      state.alquileres.splice(index, 1, alquiler);
    }
  },
  DELETE_ALQUILER(state, alquilerId) {
    state.alquileres = state.alquileres.filter(a => a.id !== alquilerId);
  },
};

const actions = {
  async fetchAlquileres({ commit }) {
    try {
      const response = await axios.get('/api/alquiler');
      commit('SET_ALQUILERES', response.data);
    } catch (error) {
      console.error('Error fetching alquileres:', error);
      throw error;
    }
  },
  async createAlquiler({ commit }, alquiler) {
    try {
      const response = await axios.post('/api/alquiler', alquiler);
      commit('ADD_ALQUILER', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating alquiler:', error);
      throw error;
    }
  },
  async updateAlquiler({ commit }, alquiler) {
    try {
      const response = await axios.put(`/api/alquiler/${alquiler.id}`, alquiler);
      commit('UPDATE_ALQUILER', response.data);
      return response.data;
    } catch (error) {
      console.error('Error updating alquiler:', error);
      throw error;
    }
  },
  async deleteAlquiler({ commit }, alquilerId) {
    try {
      await axios.delete(`/api/alquiler/${alquilerId}`);
      commit('DELETE_ALQUILER', alquilerId);
    } catch (error) {
      console.error('Error deleting alquiler:', error);
      throw error;
    }
  },
};

const getters = {
  alquileres: state => state.alquileres,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
